module.exports = JSON.parse('{"Clear dates":"Daten löschen","End Date":"Enddatum","Start Date":"Startdatum"}')